import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/broker/task/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'task_detail', false: false, filterable: true, divider: true, width: 30},
        {text: 'UID', value: 'uid', sortable: false, filterable: true, divider: true, width: 300},
        // {text: 'Source UID', value: 'source_uid', sortable: false, filterable: true, divider: true, width: 150},
        {text: 'Consumer name', value: 'consumer_name', sortable: false, filterable: true, divider: true},
        {text: 'Source name', value: 'source_name', sortable: false, filterable: true, divider: true},
        // {text: 'Source uid', value: 'source_uid', sortable: false, filterable: true, divider: true},
        {text: 'Worker ip', value: 'worker_ip', sortable: false, filterable: true, divider: true},
        // {text: 'Params', value: 'kwargs', sortable: false, filterable: true, divider: true},
        {text: 'Create on', value: 'create_on', sortable: false, filterable: true, divider: true},
        {text: 'Run on', value: 'run_on', sortable: false, filterable: true, divider: true},
        {text: 'End on', value: 'end_on', sortable: false, filterable: true, divider: true},
        {text: 'State', value: 'state', sortable: false, filterable: true, divider: true},
        {text: 'Result', value: 'result', sortable: false, filterable: true, divider: true},
        // {text: 'Error', value: 'error', sortable: false, filterable: true, divider: true},
        // {text: 'Ex', value: 'result_ex', sortable: false, filterable: true, divider: true, width: 30},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['create_on'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        TaskTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}